import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import roles from "../constants/roles";

const useUserRoleInDoc = (record) => {
	const [userRole, setUserRole] = useState();

	const workerId = Number(useSelector(
		(store) => store.authentication.userInfo.WorkerId
	));

	useEffect(() => {
		if (
			record.appointedWorkers?.find(
				(appointedWorker) => +appointedWorker.id === workerId
			)
		) {
			setUserRole(roles.APPOINTED_WORKER);
		}
		if (workerId === +record.createUser.id || workerId === +record.responsibleWorker?.id) {
			setUserRole(roles.RESPONSIBLE_OR_AUTHOR);
		}
	}, [workerId, record]);

	return userRole;
};

export default useUserRoleInDoc;
